// login.component.ts
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';
import { Store } from '@ngrx/store';
import * as actionSession from "../core/actions/session.actions";
import * as jwt_decode from "jwt-decode";
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  model: any = {};
  public submitted: any;
  constructor(
    private authService: AuthService,
    private store: Store<any>,
    private permissionService: NgxPermissionsService

  ) {}

  ngOnInit() {
    this.authService.logout();
  }

  login() {
    this.model.action = 'login';
    this.authService.loginForm(this.model).subscribe(response => {
    	console.log(response);
      if (response.status === 'success') {
        this.authService.setUser(response);

        const at = localStorage.getItem("access_token");
        if (at != null) {
          this.store.dispatch(new actionSession.CreateSession(jwt_decode(at)));
          console.log("Roles", jwt_decode(at).roles);
          this.permissionService.loadPermissions(jwt_decode(at).roles);
        }

      }
    }, error => {
      console.error(error);
    });
  }

}
